import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['show'];

  closeAll() {
    const parentList = this.element.querySelector('ul');

    if (this.closeCurrent()) return;

    this.closeSiblings(parentList);
  }

  display() {
    const parentList = this.element.parentElement;

    if (this.closeCurrent()) return;

    this.closeSiblings(parentList);

    this.showElement();
  }

  closeCurrent() {
    const isOpening = this.isShowTargetHidden();

    if (!isOpening) {
      this.hideElement();

      return true;
    }

    return false;
  }

  closeSiblings(parentList) {
    Array.from(parentList.children).forEach((sibling) => {
      if (sibling !== this.element && sibling.dataset.controller === 'toggle') {
        const siblingController =
          this.application.getControllerForElementAndIdentifier(
            sibling,
            'toggle',
          );
        if (siblingController && !siblingController.isShowTargetHidden()) {
          siblingController.hideElement();
        }
      }
    });
  }

  hide() {
    if (!this.isShowTargetHidden()) {
      this.hideElement();
    }
  }

  showElement() {
    this.element.classList.add('submenu-open');
    this.element.parentElement.classList.add('has-submenu-open');
    if (this.hasShowTarget) {
      this.showTarget.classList.remove('hidden');
    }
  }

  hideElement() {
    this.element.classList.remove('submenu-open');

    const hasOpenSiblings = Array.from(
      this.element.parentElement.children,
    ).some(
      (child) =>
        child !== this.element && child.classList.contains('submenu-open'),
    );

    if (!hasOpenSiblings) {
      this.element.parentElement.classList.remove('has-submenu-open');
    }

    if (this.hasShowTarget) {
      this.showTarget.classList.add('hidden');
      const nestedControllers = this.showTarget.querySelectorAll(
        '[data-controller="toggle"]',
      );
      nestedControllers.forEach((controllerElement) => {
        const controller =
          this.application.getControllerForElementAndIdentifier(
            controllerElement,
            'toggle',
          );
        if (controller) {
          controller.hideElement();
        }
      });
    }

    if (this.element.contains(document.activeElement)) {
      const active = document.activeElement;
      const ancestor = active.closest('.mega-menu--multiLevel');
      const sibling = ancestor?.parentElement?.querySelector('.nav__menu-link');

      active.blur();
      sibling.focus();
    }
  }

  isShowTargetHidden() {
    return !this.hasShowTarget || this.showTarget.classList.contains('hidden');
  }
}
